export const organizationsTableStyle = {
  wrapper: {
    background: 'var(--default-white)',
    padding: '12px 16px',
    width: '100%',
    height: '100%',
    minHeight: 'calc(100vh - 128px)',
    boxShadow: 'var(--box-shadow--1)',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },

  tableContent: {
    position: 'relative',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  container: {
    overflowX: 'hidden',
  },

  table: {
    minWidth: 650,
    tableLayout: 'fixed',
    borderCollapse: 'separate',
    borderSpacing: '0 8px',
  },

  tableHeader: {
    height: '32px',

    '& > :nth-of-type(1)': {
      width: '7%',
    },
    '& > :nth-of-type(2)': {
      width: '21%',
    },
    '& > :nth-of-type(3)': {
      width: '24%',
    },
    '& > :nth-of-type(4)': {
      width: '15%',
    },
    '& > :nth-of-type(5)': {
      width: '10%',
      textAlign: 'right',
    },
    '& > :nth-of-type(6)': {
      width: '12%',
      textAlign: 'right',
    },
    '& > :nth-of-type(7)': {
      width: '6%',
    },
    '& > :nth-of-type(8)': {
      width: '5%',
    },
  },

  headerCellTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },

  sortIcon: {
    width: '20px',
    display: 'flex',
    alignItems: 'center',
  },

  tableBody: {
    '& > :nth-of-type(4)': {
      '@media (max-width: 1023.98px)': {
        display: 'none',
      },
    },

    '& .MuiTableCell-root': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      height: '58px',
      padding: '7px',
    },
  },

  nameCell: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
  },

  avatar: {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,

    img: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },

  name: {
    fontWeight: '700 !important',
    color: 'var(--neutral-900)',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  },

  textID: {
    fontSize: '12px',
  },

  email: {
    color: 'var(--neutral-300) !important',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
  },

  statusActive: {
    color: 'var(--success-600) !important',
    textAlign: 'right',

    '&:after': {
      paddingLeft: '10px',
      content: "'·'",
      fontSize: '23px',
    },
  },

  statusDeactivated: {
    color: 'var(--error-600) !important',
    textAlign: 'right',

    '&:after': {
      paddingLeft: '10px',
      content: "'·'",
      fontSize: '23px',
    },
  },

  menu: {
    '&.MuiTableCell-body': {
      padding: '0 5px',
    },
  },

  menuItem: {
    width: '100%',
    padding: '8px 16px',
    cursor: 'pointer',
    textTransform: 'capitalize',

    '&:hover': {
      backgroundColor: 'var(--background-grey-op-50-1)',
    },
  },

  paginationContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '40px',
  },

  loader: {
    position: 'absolute',
    left: 'calc(50% - 25px)',
    top: '200px',
  },

  statusModal: {
    '.MuiPaper-root': {
      maxWidth: '770px',
      padding: '48px 200px',
      width: '100%',
    },
  },

  detailsModal: {
    '.MuiPaper-root': {
      position: 'relative',
      maxWidth: '1170px',
      width: '100%',
      maxHeight: 'calc(100% - 48px)',
      height: '100%',
      padding: '48px 38px 18px 48px',
      scrollbarGutter: 'stable',
      margin: '0 15px',
      borderRadius: '8px',

      '& > .MuiBox-root': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },

  textWrapper: {
    marginTop: '8px',
    textAlign: 'center',
  },

  description: {
    display: 'inline',
    color: 'var(--neutral-300)',
    textAlign: 'center',
  },

  descriptionBottom: {
    color: 'var(--neutral-300)',
    textAlign: 'center',
    marginTop: '16px',
  },

  boldCenter: {
    color: 'var(--neutral-600)',
    textAlign: 'center',
    fontWeight: '700',
  },

  bold: {
    color: 'var(--neutral-600)',
    fontWeight: '700',
    display: 'inline',
  },

  modal: {
    '.MuiPaper-root': {
      maxWidth: '770px',
      padding: '48px 200px',
      width: '100%',
    },
  },

  arrow: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& svg': {
      width: '17px',
      height: '17px',
      transition: 'transform 0.2s ease-in-out',

      path: {
        fill: 'var(--neutral-500)',
      },
    },
  },

  selectedRow: {
    '& .MuiTableCell-root': {
      backgroundColor: 'var(--primary-100) !important',
    },
    '& .MuiTableCell-root:first-of-type': {
      borderTopLeftRadius: '8px !important',
      borderBottomLeftRadius: '8px !important',
    },
    '& .MuiTableCell-root:last-of-type': {
      borderTopRightRadius: '8px !important',
      borderBottomRightRadius: '8px !important',
    },
  },

  membersWrapper: {
    backgroundColor: 'var(--neutral-50)',
    borderBottom: '1px solid #E0E0E0',
    padding: '0px !important',
  },

  membersHeaderRow: {
    backgroundColor: 'var(--neutral-50) !important',
  },

  membersHeaderCell: {
    backgroundColor: 'var(--neutral-50) !important',
    fontWeight: 600,
    color: '#6B7280',
    borderBottom: '1px solid #E0E0E0',
  },

  owner: {
    color: 'var(--neutral-300) !important',
  },

  member: {
    color: 'var(--primary-500) !important',
  },

  lastActiveInvited: {
    color: 'var(--warning-600) !important',
    textAlign: 'right',
    whiteSpace: 'nowrap',

    '&:after': {
      paddingLeft: '10px',
      content: "'·'",
      fontSize: '23px',
    },
  },
  lastActiveDate: {
    color: 'var(--neutral-600)',
    textAlign: 'right',

    '&:after': {
      paddingLeft: '10px',

      content: "'·'",
      fontSize: '23px',
    },
  },
};
